const selectors = {
  BREADCRUMB_ITEM_SELECTOR: '[data-selector="breadcrumb"]',
  BREADCRUMB_EXPAND_SELECTOR: '[data-selector="breadcrumb-expand"]',
};

const classes = {
  HIDDEN: 'hidden',
};

class Breadcrumbs extends HTMLElement {
  constructor() {
    super();
    this.breadcrumbExpandEl = null;
    this.breadcrumbItemEls = null;
    this.abortController = null;
  }

  connectedCallback() {
    this.abortController = new AbortController();
    this.breadcrumbExpandEl = this.querySelector(selectors.BREADCRUMB_EXPAND_SELECTOR);
    this.breadcrumbItemEls = this.querySelectorAll(selectors.BREADCRUMB_ITEM_SELECTOR);

    this.breadcrumbExpandEl?.addEventListener('click', this.handleExpandBreadcrumb.bind(this), {
      signal: this.abortController?.signal,
    });
  }

  handleExpandBreadcrumb() {
    if (!this.breadcrumbItemEls || !this.breadcrumbExpandEl) return;

    this.breadcrumbItemEls.forEach((item) => item.classList.remove(classes.HIDDEN));
    this.breadcrumbExpandEl.parentElement?.classList?.add(classes.HIDDEN);
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }
}

if (!customElements.get('breadcrumb-nav')) {
  customElements.define('breadcrumb-nav', Breadcrumbs);
}
